var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hot-table',{ref:"hottable",attrs:{"license-key":_vm.licenseKey,"data":_vm.data,"col-headers":_vm.colHeaders,"columns":_vm.columns,"settings":_vm.settings,"after-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }